<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">콜렉션 페이지 생성</h2>
      <div class="flexBox">
        <div class="flexInner">
          <div class="mb15 isRequired">
            <div class="innerTitle setLabel">{{locale.name}}</div>
            <input
              type="text"
              class="input"
              v-model="name">
          </div>
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" :disabled="!isValid" @click="create">{{locale.do_create}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'

export default {
  name: 'CreatePage',
  props: [
    'locale'
  ],
  components: {
  },
  computed: {
    isValid () {
      const name = this.name.length > 0
      return name
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
      name: '',
      catCode: ''
    }
  },
  methods: {
    async init () {
    },
    async create () {
      const data = {
        pageName: this.name,
        catCode: 'system_collection_service'
      }
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/initCollectionPage', data)
      const pageId = res && res.message && res.message.pageId
      if (pageId) {
        this.$router.push({
          name: 'collectionPage',
          params: {
            pageId: pageId
          }
        })
      } else {
        alert('지원하지 않는 서비스입니다.\n관리자에 문의해 주세요.')
        this.$router.replace('/')
      }
      this.$store.commit('onLoading', false)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 400px;
  }
}
.isRequired {
  .innerTitle {
    padding-left: 18px;
    &:after {
      content: "*";
      position: absolute;
      top: 0;
      left: 8px;
      color: $color-red;
    }
  }
}
</style>
